<script setup lang="ts">
import { computed } from 'vue'
import { UnionColorKeys } from '@/types/global'
import { findColorValue } from '@/utils/style/'

const props = withDefaults(
  defineProps<{
    label: string
    color: UnionColorKeys
    fontSize?: `${string}${'px'}`
    fontColor?: UnionColorKeys
  }>(),
  {
    fontSize: '10px',
    fontColor: 'white',
  }
)

const colorValue = computed(() => findColorValue(props.color))
const fontColorValue = computed(() => findColorValue(props.fontColor))
</script>

<template>
  <span class="badge">{{ props.label }}</span>
</template>

<style lang="scss" scoped>
.badge {
  display: inline-block;
  color: v-bind(fontColorValue);
  box-sizing: border-box;
  padding: 5px 10px;
  font-size: v-bind(fontSize);
  line-height: 1;
  border-radius: 11px;
  background-color: v-bind(colorValue);
}
</style>
